"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysPerMonth = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.daysPerMonth = function (year) {
    var isLeapYear = year === undefined ? false : moment_timezone_1.default(year, 'Y').isLeapYear();
    return [31, isLeapYear ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
};
